import React from 'react';

// Helper component for logo images
const BrandLogo = ({ name, ext = 'svg', size = 24 }: { name: string; ext?: string; size?: number }) => (
  <img 
    src={`/logos/${name}.${ext}`} 
    alt={`${name} logo`}
    width={size} 
    height={size}
    style={{ objectFit: 'contain' }}
    onError={(e) => {
      // Fallback to show the name/initials if image is missing
      e.currentTarget.style.display = 'none';
      e.currentTarget.parentElement?.classList.add('fallback-icon');
    }} 
  />
);

export const JiraIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="jira" ext="png" size={size} />
);

export const ConfluenceIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="confluence" ext="jpeg" size={size} />
);

export const GitHubIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="github" ext="png" size={size} />
);

export const AzureDevOpsIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="azure-devops" ext="png" size={size} />
);

export const SlackIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="slack" ext="jpg" size={size} />
);

export const TeamsIcon = ({ size = 24 }: { size?: number }) => (
  <BrandLogo name="teams" ext="jpg" size={size} />
);

